<div class="flex w-full flex-col p-4">
  <div class="flex flex-row justify-between">
    <div class="flex flex-col justify-center">
      <div class="pl-2 text-xl">Test Video</div>
      <div class="mx-auto mt-12 w-full rounded-xl bg-white p-4 shadow-md lg:mt-6">
        <div class="rounded-t-xl">
          <mat-tab-group [selectedIndex]="activeTab" (selectedTabChange)="onTabChange($event)" class="test-tabs">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="text-[0.875rem] font-medium leading-5">CPU</span>
              </ng-template>
              <app-cpu></app-cpu>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="text-[0.875rem] font-medium leading-5">GPU</span>
              </ng-template>
              <app-gpu></app-gpu>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="text-[0.875rem] font-medium leading-5">Screen Share</span>
              </ng-template>
              <app-screenshare></app-screenshare>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
